import React from 'react'
import { Loader } from 'semantic-ui-react'

const Spinner = () => {
    return (<Loader active inline='centered' />)
}

export default Spinner
